import React from 'react'
import { classNames as cn } from '~/helpers/string'

type LinkProps<T extends React.ElementType = 'a'> = {
  as?: T
  children?: React.ReactNode
  className?: string
} & React.ComponentPropsWithoutRef<T>

export const Link = <T extends React.ElementType = 'a'>(props: LinkProps<T>) => {
  const { as, className = '', ...rest } = props
  const Component = as || 'a'

  return (
    <Component
      className={cn(
        "relative text-sm font-normal leading-5 text-brand-gray-700 after:absolute after:bottom-0 after:block after:h-px after:w-full after:rounded after:bg-brand-primary-300 after:content-['']",
        className,
      )}
      {...rest}
    />
  )
}
